/**
 * Shared v3 motion tokens — toned-down enters/springs aligned with menu-flow optimizations.
 */
import type { AnimatedSectionProps } from '../../../components/ui/AnimatedSection';

export const SOFT_SPRING = { damping: 42, stiffness: 280, mass: 0.55 };

export const ENTER_DURATION_MS = 180;
export const ENTER_STAGGER_MS = 32;

export const LIST_ENTER_DURATION_MS = 200;
export const LIST_ENTER_STAGGER_MS = 28;
export const LIST_ENTER_MAX_STAGGER_INDEX = 4;
export const LIST_ENTER_TRANSLATE_Y = 12;

/** Stacked carousel — softer parallax / scale while swiping category slides. */
export const STACK_CAROUSEL_PARALLAX = 0.28;
export const STACK_CAROUSEL_INACTIVE_SCALE = 0.94;

/** Hub screens (accounts, dashboard sections): timing-only fade-down with light stagger. */
export const HUB_SECTION_PROPS: Pick<AnimatedSectionProps, 'variant' | 'useSpring' | 'staggerMs' | 'duration'> = {
  variant: 'fadeDown',
  useSpring: false,
  staggerMs: ENTER_STAGGER_MS,
  duration: ENTER_DURATION_MS,
};

export function cappedListEnterDelay(index: number, step_ms = LIST_ENTER_STAGGER_MS): number {
  return Math.min(Math.max(0, index), LIST_ENTER_MAX_STAGGER_INDEX) * step_ms;
}
